import { Box, FormLabel, Grid, Icon, IconButton, Typography, useTheme } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { DeleteEmployeeNoteRequest, VovClient } from '../../../../ApiOld/ApiServerVov';
import { useTranslation } from 'react-i18next';
import { Inject } from '@syncfusion/ej2-react-grids';
import { RichTextEditorComponent } from '@syncfusion/ej2-react-richtexteditor';
import { ChangeEventArgs, HtmlEditor, QuickToolbar, Toolbar, Link } from '@syncfusion/ej2-richtexteditor';
import { Delete, Edit, Padding } from '@mui/icons-material';
import { useApi } from '../../../../ApiOld/Api/useApi';
import DeleteDialog from '../../../Shared/Layouts/DeleteDialog';
import { EmployeeNoteDTO } from '../../../../ApiOld/Api/ApiServerVov';
import RenameNoteDialog from '../../ProjectComponents/Dialogs/RenameNoteDialog';
import { useEmployeesPermissionContext } from '../../../../Contexts/Permissions/EmployeesPermissionContext';

interface EmployeeNotesItemProps {
    note: EmployeeNoteDTO;
    toolbarSettings: object;
    onNoteChange: (note: EmployeeNoteDTO) => void;
    onDelete: (id: number) => void;
}

export default function EmployeeNotesItem(props: EmployeeNotesItemProps) {
    const { note, toolbarSettings, onNoteChange, onDelete } = props;
    const { t, i18n } = useTranslation();
    const { authorizedApi } = useApi(VovClient);
    const [openRenameDialog, setOpenRenameDialog] = useState<boolean>(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);

    const theme = useTheme();

    const { permissions, reloadPermissions } = useEmployeesPermissionContext();

    useEffect(() => {
        if (!permissions)
            reloadPermissions();
    }, [reloadPermissions]);

    return <Grid item xs={12} lg={6}>
        <Box style={{ margin: '16px', border: '1px solid lightgray', borderRadius: '10px', marginTop: '0px' }} >
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <FormLabel sx={{ marginLeft: '24px', marginBottom: '0px', fontWeight: 'bold', marginTop: '8px' }}>{note.name}</FormLabel>
                <Box sx={{ display: 'flex', alignItems: 'center', marginRight: '12px' }}>
                    <IconButton size='small' color="secondary" onClick={(e) => {
                        setOpenRenameDialog(true);
                    }}>
                        <Edit />
                    </IconButton>
                    <IconButton size='small' color="secondary" onClick={(e) => {
                        setDeleteDialogOpen(true)
                    }}>
                        <Delete />
                    </IconButton>
                </Box>
            </Box>

            <RichTextEditorComponent readonly={!permissions || !permissions.employeesEdit} style={{ borderWidth: 0, borderRadius: '10px', overflow: 'hidden', marginBottom: '-1px' }} locale={i18n.language} value={note.text} change={(eve: ChangeEventArgs) => {
                console.log(eve.value, new EmployeeNoteDTO({ ...note, text: eve.value }));
                onNoteChange(new EmployeeNoteDTO({ ...note, text: eve.value }));
            }} toolbarSettings={toolbarSettings}>
                <Inject services={[Toolbar, Link, HtmlEditor, QuickToolbar]} />
            </RichTextEditorComponent>

            <RenameNoteDialog open={openRenameDialog} onClose={() => { setOpenRenameDialog(false); }} onConfirm={(name) => {
                onNoteChange(new EmployeeNoteDTO({ ...note, name: name }));
            }} oldName={note.name!} />

            <DeleteDialog onClose={() => setDeleteDialogOpen(false)} open={deleteDialogOpen} data={undefined} onDeleteAgree={() => {
                if (note.id && note.id > 0)
                    authorizedApi.deleteEmployeeNote(new DeleteEmployeeNoteRequest({ id: note.id })).then((r) => {
                        if (r.ok) {
                            onDelete(note.id!);
                        }
                    });
                else
                    onDelete(note.id!);
            }} />
        </Box>
    </Grid>;
}
